<template>
  <PlayerSmallMobile class="dt:hidden" />
  <PlayerSmallDesktop class="hidden dt:block" />
</template>
